import { ArrowForward, Close, Done } from "@mui/icons-material";
import { Box, TextField } from "@mui/material";
import playstore from "../../../../../assets/images/googlePlayStore.png";
import appstore from "../../../../../assets/images/appStore.png";
import { SalesAidsStyles } from "./SalesAidsStyles";
import Theme from "../../../../../utils/Theme";
import { Typography } from "@mui/material";

const DealerEngagement = ({ artifacts, setArtifacts, handleArrowClick }) => {
  const handleTextChange = (field, value) => {
    setArtifacts((prev) => ({
      ...prev,
      dealer_app: {
        ...prev.dealer_app,
        [field]: value,
        isEdit: true,
      },
    }));
  };

  const hasEnglish = artifacts?.message?.trim() && (artifacts?.playstore || artifacts?.appstore);
  const hasSpanish = artifacts?.es_message?.trim() && (artifacts?.playstore || artifacts?.appstore);
  const isValid = hasEnglish || hasSpanish;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        p: "15px 6px 6px 6px",
        borderRadius: 2,
        bgcolor: artifacts?.isEdit ? "#FFF7F7" : null,
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
          height: "100%",
          gap: 2,
        }}
      >
        {/* English Section */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography fontSize={15} fontWeight="bold" color="gray">
            English
          </Typography>

          <TextField
            fullWidth
            multiline
            label="Message to be displayed"
            value={artifacts?.message || ""}
            onChange={(e) => handleTextChange("message", e.target.value)}
          />
        </Box>

        {/* Spanish Section */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography fontSize={15} fontWeight="bold" color="gray">
            Spanish
          </Typography>

          <TextField
            fullWidth
            multiline
            label="Mensaje a mostrar"
            value={artifacts?.es_message || ""}
            onChange={(e) => handleTextChange("es_message", e.target.value)}
          />
        </Box>

        {/* Action Button */}
        {artifacts?.isEdit ? (
          <Done
            sx={{
              fontSize: 20,
              mt: "55px",
              color: isValid ? Theme.palette.primary.main : Theme.palette.action.disabled,
              cursor: isValid ? "pointer" : "not-allowed",
            }}
            onClick={() => isValid && handleArrowClick(artifacts, "dealer_app")}
          />
        ) : (
          <ArrowForward
            sx={{
              ...SalesAidsStyles.arrowForward,
              mt: "32px",
              color: isValid ? Theme.palette.primary.main : Theme.palette.action.disabled,
              cursor: isValid ? "pointer" : "not-allowed",
            }}
            onClick={() => isValid && handleArrowClick(artifacts, "dealer_app")}
          />
        )}
      </Box>

      {/* Playstore */}
      <Box sx={SalesAidsStyles.artifactBox}>
        <img src={playstore} width={50} />
        <TextField
          fullWidth
          variant="outlined"
          label={"Link"}
          onChange={(e) => handleTextChange("playstore", e.target.value)}
          value={artifacts?.playstore || ""}
          multiline
        />
      </Box>

      {/* Appstore */}
      <Box sx={SalesAidsStyles.artifactBox}>
        <img src={appstore} width={50} />
        <TextField
          fullWidth
          variant="outlined"
          label={"Link"}
          onChange={(e) => handleTextChange("appstore", e.target.value)}
          value={artifacts?.appstore || ""}
          multiline
        />
      </Box>
    </Box>
  );
};

export default DealerEngagement;
